import React from 'react'


export const TitlesPage = ({ThemeItems, themeListCount}) => {
    return (<>
        <div>Not available</div>
    </>)
}
